module.exports = __webpack_public_path__ + "img/pic3.86149f76.jpg";